import moment from 'moment';
import _ from 'lodash';
import {
  CreateEditReceiptInventoryEnum,
  ItemEnum,
  FilterEnum,
  ReceiptSaveOptionEnum,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import {
  CreateEditReceiptInventoryEnum as StatusEnum,
} from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';
import {  BracketTypeEnum} from  'Common/Constants/Enumeration/ManageProcessOrderEnum';
import {
  dollarCalculation,
  quantityCalculation,
  weightCalculation,
} from 'Common/FormHelper';

export const basicURL = '/managepurchaseorder';

export const getTotalMerchandiseAmount = orderItemsInfo => {
  let CalculateCostPerServing = 0,
    totalValue = 0;
  if (orderItemsInfo && orderItemsInfo.length) {
    totalValue = _.reduce(
      orderItemsInfo,
      (total, prevItem) => {
        if (
          !prevItem.BracketType ||
          prevItem.BracketType === BracketTypeEnum.None
        ) {
          if ((prevItem.PriQty || prevItem.SecQty) && +prevItem.QtyPerUnit) {
            if (+prevItem.PrimaryPrice) {
              CalculateCostPerServing =
                prevItem.PrimaryPrice / prevItem.QtyPerUnit;
            }
          }
          if (prevItem.PriQty && !isNaN(prevItem.PriQty)) {
            total += prevItem.PrimaryPrice * +prevItem.PriQty;
          }
          if (prevItem.SecQty && !isNaN(prevItem.SecQty)) {
            total += CalculateCostPerServing * prevItem.SecQty;
          }
        } else if (prevItem.BracketType === BracketTypeEnum.Dollars) {
          total += dollarCalculation(
            prevItem,
            +prevItem.BracketPricingDetails[0].Price
          );
        } else if (prevItem.BracketType === BracketTypeEnum.Quantity) {
          total += quantityCalculation(prevItem);
        } else if (prevItem.BracketType === BracketTypeEnum.Weight) {
          total += weightCalculation(prevItem);
        }
        return total;
      },
      0
    );
  }
  return totalValue.toFixed(4);
};

export const filterDataSource = (
  orderItemsInfo,
  orderItemsData,
  change,
  fieldName
) => {
  if (
    orderItemsInfo &&
    orderItemsInfo.length &&
    orderItemsData &&
    orderItemsData.length
  ) {
    const dataSourceCopy = _.cloneDeep(orderItemsData);
    const valueCopy = _.cloneDeep(orderItemsInfo);
    const removeValues = [];
    let index;
    _.each(valueCopy, item => {
      index = _.findIndex(dataSourceCopy, {
        [ItemEnum.ItemCode]: item[ItemEnum.ItemCode],
      });
      if (index === -1) {
        removeValues.push({ ...item });
      }
    });
    removeValues.length && _.pullAllBy(valueCopy, removeValues, 'ItemCode');
    change(fieldName, valueCopy);
  }
};
export const getSavePOWOObject = (values, IsWarehouseOrder, TransactionId) => {
  let saveObj = {
    TransactionId,
    ShippingCost: values.ShippingCost,
    Comments: values.Comments ? values.Comments : '',
    IsWarehouseOrder,
    PONum: values.PONum,
    POItemDetails: values.POItemDetails,
  };
  return saveObj;
};
export const getTotalTaxCostAmount = poItemDetails => {
  let CalculateCostPerServing = 0,
    totalTaxCostAmount = 0;
  if (poItemDetails && poItemDetails.length) {
    totalTaxCostAmount = _.reduce(
      poItemDetails,
      (totalTax, item) => {
        let cost = 0.0;
        if ((item.PriQty || item.SecQty) && +item.QtyPerUnit) {
          if (+item.PrimaryPrice) {
            CalculateCostPerServing = item.PrimaryPrice / item.QtyPerUnit;
          }
        }
        if (item.PriQty && !isNaN(item.PriQty)) {
          cost += item.PrimaryPrice * +item.PriQty;
        }
        if (item.SecQty && !isNaN(item.SecQty)) {
          cost += CalculateCostPerServing * item.SecQty;
        }
        const totalTaxOnItem = _.add(
          _.add(item.FederalTax, item.StateTax),
          _.add(item.CountyTax, item.LocalTax)
        );
        if (totalTaxOnItem) {
          const netCost = cost + +item.ShippingCost - +item.DiscountAmount;
          totalTax += netCost * (totalTaxOnItem / 100.0);
        }
        return totalTax;
      },
      0
    );
  }
  return totalTaxCostAmount.toFixed(4);
};

export const getTotalCostAmount = poItemDetails => {
  const price = getTotalMerchandiseAmount(poItemDetails);
  const tax = getTotalTaxCostAmount(poItemDetails);
  const totalCostAmount = _.add(+price, +tax);
  return totalCostAmount.toFixed(4);
};

export const makeSaveReceiptObject = (
  values,
  receiptId,
  IsNewEdit,
  orderItemsInfo,
  SaveOptionEnum,
  siteName,
  vendorName,
  selectedReceiptOrder,
  selectedReceiptPOItemDetails
) => {
  const IsWarehouseOrder =
    IsNewEdit === StatusEnum.EDIT
      ? values[CreateEditReceiptInventoryEnum.IsWarehouseOrder]
      : false;
  let POWONum = null;
  if (IsNewEdit === StatusEnum.EDIT) {
    POWONum = values[CreateEditReceiptInventoryEnum.WONumber];
  }
  const saveObj = {
    POWONum,
    IsWarehouseOrder: IsWarehouseOrder,
    Comments: values[CreateEditReceiptInventoryEnum.Comments],
    Invoice: values[CreateEditReceiptInventoryEnum.Invoice],
    TotalMerchandiseCost: getTotalMerchandiseAmount(orderItemsInfo),
    POItemDetails: [],
    ReceiptId: receiptId,
    OrderId:
      IsNewEdit === StatusEnum.EDIT
        ? values[CreateEditReceiptInventoryEnum.OrderId]
        : null,
    OrderDT:
      IsNewEdit === StatusEnum.EDIT &&
      values[CreateEditReceiptInventoryEnum.OrderDT]
        ? moment(values[CreateEditReceiptInventoryEnum.OrderDT]).format(
            DATE_FORMAT_FOR_SERVER
          )
        : null,
    ReceiptDt: CreateEditReceiptInventoryEnum.ReceiptDt
      ? moment(values[CreateEditReceiptInventoryEnum.ReceiptDt]).format(
          DATE_FORMAT_FOR_SERVER
        )
      : null,
    VendorId: values[FilterEnum.ReceiptVendorId],
    SiteId: values[ItemEnum.SiteId],
    VendorName: vendorName,
    SiteName: siteName,
    SaveOption: ReceiptSaveOptionEnum[SaveOptionEnum],
    WarehouseSiteId: IsWarehouseOrder
      ? selectedReceiptOrder[ItemEnum.WarehouseSiteId]
      : null,
  };
  _.forEach(
    values[CreateEditReceiptInventoryEnum.ReceiptOrderItemsInfo],
    item => {
      if (item.PriQty || item.SecQty) {
        const obj = {
          AllowPartialOrdering: item[ItemEnum.AllowPartialOrdering],
          ItemCode: item[ItemEnum.ItemCode],
          ItemId: item[ItemEnum.ItemId],
          ItemDescription: item[ItemEnum.Description]
            ? item[ItemEnum.Description]
            : item[ItemEnum.ItemDescription],
          ItemPackaging: item[ItemEnum.ItemPackaging],
          OrderQty: item[ItemEnum.OrderQty],
          PrimaryPrice: +item[ItemEnum.PrimaryPrice],
          PrimaryQty: item[ItemEnum.PriQty] ? item[ItemEnum.PriQty] : 0,
          QtyPerUnit: item[ItemEnum.QtyPerUnit],
          SecondaryQty: item[ItemEnum.SecQty] ? item[ItemEnum.SecQty] : 0,
          SecondaryUnit: item[ItemEnum.SecondaryUnit],
          SiteId: values[ItemEnum.SiteId],
          Unit: item[ItemEnum.Unit],
          VendorItem: item[ItemEnum.VendorItem],
        };
        if (
          IsNewEdit === StatusEnum.EDIT &&
          selectedReceiptPOItemDetails &&
          selectedReceiptPOItemDetails.length
        ) {
          const data = _.find(selectedReceiptPOItemDetails, poItem => {
            return poItem[ItemEnum.ItemCode] === item[ItemEnum.ItemCode];
          });
          if (data) {
            obj[ItemEnum.TransactionDetailId] =
              data[ItemEnum.TransactionDetailId];
            obj[ItemEnum.TransactionId] = data[ItemEnum.TransactionId];
          }
        }
        saveObj.POItemDetails.push(obj);
      }
    }
  );
  return saveObj;
};

export const validateInput = newValue => {
  if (newValue.startsWith('-')) {
    const qty = newValue.split('-')[1].replace(/-/g, '');
    newValue = '-' + qty;
  } else {
    newValue = newValue.replace(/-/g, '');
  }
  const indexOfDecimal = newValue.indexOf('.');
  if (indexOfDecimal > 1) {
    const prevValue = newValue.substr(0, indexOfDecimal);
    const value = newValue
      .substr(indexOfDecimal, newValue.length)
      .replace(/\./g, '');
    newValue = prevValue + '.' + value;
  }
  return newValue;
};

export const validateForReceiptInventory = values => {
  const errors = {};

  if (
    !values[CreateEditReceiptInventoryEnum.Invoice] ||
    !_.trim(values[CreateEditReceiptInventoryEnum.Invoice]).length
  ) {
    errors[CreateEditReceiptInventoryEnum.Invoice] = 'Invoice is required.';
  }
  if (
    !values[FilterEnum.ReceiptVendorId] ||
    values[FilterEnum.ReceiptVendorId] === StatusEnum.NEW
  ) {
    errors[FilterEnum.ReceiptVendorId] = 'Distributor is required.';
  }
  if (
    !values[ItemEnum.SiteId] ||
    values[FilterEnum.SiteId] === StatusEnum.NEW
  ) {
    errors[FilterEnum.SiteId] = 'Site is required.';
  }
  return errors;
};

export const OrderTypeEnum = {
  NewType: 'newType:',
};



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/helper/index.js